export enum InsureeTypeEnum {
  COMPANY = 'company',
  PERSON = 'person',
}
